/*jshint esversion: 6 */
const findByProperty = function (sites, property, value, returnIndex) {
    if (returnIndex) {
        const index = sites.findIndex(site => {
            if (site.hasOwnProperty(property) && site[property] !== undefined) {
                return site[property].toString() === value.toString();
            } else {
                return false;
            }

        });

        return index === -1 ? undefined : index;
    } else {
        return sites.find(site => {
            if (site.hasOwnProperty(property)  && site[property] !== undefined) {
                return site[property].toString() === value.toString();
            } else {
                return false;
            }

        });
    }
};

export default {
    byId(whereToFind, valueToFind, returnIndex) {
        return findByProperty(whereToFind, 'id', valueToFind, returnIndex);
    },
    byName(whereToFind, valueToFind, returnIndex) {
        return findByProperty(whereToFind, 'name', valueToFind, returnIndex);
    },
    byPosition(whereToFind, valueToFind, returnIndex) {
        return findByProperty(whereToFind, 'position', valueToFind, returnIndex);
    },
    bySection(whereToFind, valueToFind, returnIndex) {
        return findByProperty(whereToFind, 'section', valueToFind, returnIndex);
    }


};